export default "__VITE_ASSET__FZh7NAPP__"